/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Nav_TutorialInputs */

const en_fc_nav_tutorial = /** @type {(inputs: Fc_Nav_TutorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial`)
};

/**
* | output |
* | --- |
* | "Tutorial" |
*
* @param {Fc_Nav_TutorialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_nav_tutorial = /** @type {((inputs?: Fc_Nav_TutorialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Nav_TutorialInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_nav_tutorial(inputs)
});
export { fc_nav_tutorial as "fc.nav.tutorial" }